<template>
    <div v-if="vehicleId" class="quick-actions">
        <button
            type="button"
            class="quick-action"
            v-b-tooltip.hover.top="__('view_infringements')"
            :aria-label="__('view_infringements')"
            @click="openGoliaInfringements({ vehicleId })"
        >
            <i class="fa-solid fa-record-vinyl"></i>
        </button>
        <button
            v-if="hasTachographData"
            type="button"
            class="quick-action"
            v-b-tooltip.hover.top="__('view_tachograph_activities')"
            :aria-label="__('view_tachograph_activities')"
            @click="openGoliaTachographActivities({ vehicleId })"
        >
            <i class="fa-regular fa-gauge-high"></i>
        </button>
    </div>
</template>

<script>
import goliaLegacyLinks from '@/mixins/goliaLegacyLinks'

export default {
    name: 'VehicleQuickActions',
    mixins: [goliaLegacyLinks],
    props: {
        truck: {
            type: Object,
            default: null
        }
    },
    computed: {
        vehicleId() {
            const id = this.truck?.id
            return id && id > 0 ? id : null
        },
        hasTachographData() {
            // Il tachigrafo è disponibile solo se il veicolo ha effettivamente
            // caricato un file DDD. `this.moment` (Dater) ritorna null per date
            // non valide/vuote (es. null, "" o "0000-00-00 00:00:00"): basta
            // quindi verificarne la truthiness. Il guard su `upload` è necessario
            // perché `this.moment(undefined)` restituirebbe la data corrente.
            const upload = this.truck?.details?.ddd_last_upload
            return !!this.vehicleId && !!upload && !!this.moment(upload)
        }
    }
}
</script>

<style scoped lang="scss">
@use './styles/quickActions.scss';
</style>
